module.exports = __webpack_public_path__ + "img/ZSD.bb0d70b6.svg";